import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	refinementOptionRecentProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refinementOptionRecentProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	refinementOptionRecentProjects: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects',
		defaultMessage: 'Recent projects',
		description: 'Recent projects subtitle in issue navigator refinement dropdown',
	},
	refinementOptionRecentProjectsGalaxia: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects-galaxia',
		defaultMessage: 'Recent spaces',
		description: 'Recent projects subtitle in issue navigator refinement dropdown',
	},
});
export default messages;
